import { useEffect, useRef, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { linksConfig } from './config/links'
import { Hero } from './components/Hero'
import { LinkGrid } from './components/LinkGrid'
import { Footer } from './components/Footer'
import { EasterEggs } from './components/EasterEggs'
import { SeasonalTheme } from './components/SeasonalTheme'
import { konamiCode } from './utils/konami'

function App() {
  const [mounted, setMounted] = useState(false)
  const [konamiActivated, setKonamiActivated] = useState(false)
  const konamiRef = useRef(konamiCode(() => setKonamiActivated(true)))

  useEffect(() => {
    setMounted(true)
    document.body.classList.add('noise-bg')
  }, [])

  useEffect(() => {
    const handler = (e: KeyboardEvent) => konamiRef.current(e)
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [])

  const currentTheme = SeasonalTheme.getCurrent()

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] }}
      className="min-h-[100dvh] flex flex-col relative overflow-x-hidden"
      style={{
        '--theme-accent': currentTheme.accent,
        '--theme-accent-glow': currentTheme.glow,
      } as React.CSSProperties}
    >
      <SeasonalTheme.Provider>
        <AnimatePresence mode="wait">
          {mounted && (
            <>
              <Hero />
              <LinkGrid links={linksConfig} />
              <Footer />
              <EasterEggs konamiActivated={konamiActivated} onKonamiClose={() => setKonamiActivated(false)} />
            </>
          )}
        </AnimatePresence>
      </SeasonalTheme.Provider>
    </motion.div>
  )
}

export default App